import { formatMoney } from 'common/services/format'

import { ReactComponent as RingIcon } from '../assets/ring.svg'

import styles from './waiting-view.module.scss'

type Props = {
  amount: number
  terminalLabel: string
  message?: string
}

export const WaitingView = ({ amount, terminalLabel, message }: Props) => {
  return (
    <div className={styles.container}>
      <div className={styles.ringWrapper}>
        <RingIcon className={styles.ringIcon} width={96} height={96} />
      </div>
      <div className={styles.textGroup}>
        <h3 className={styles.title}>Waiting for payment...</h3>
        <p className={styles.subtitle}>
          Present the card on
          {terminalLabel && <span className={styles.terminalName}>{terminalLabel}</span>}
        </p>
        {message && <p className={styles.message}>{message}</p>}
      </div>
      <div className={styles.amountCard}>
        <span className={styles.amountLabel}>Amount due</span>
        <span className={styles.amountValue}>
          <span className={styles.amountSymbol}>$</span>
          {formatMoney(amount).replace(/^\$/, '')}
        </span>
      </div>
    </div>
  )
}
